import dayjs from 'dayjs';
import React, {useContext, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import styled, {ThemeContext} from 'styled-components';
import images from '../config/images';


const HeaderWrapper = styled.div`
    width: 100%;
    height: ${props => props.theme.scale * 215}px;
    background-color: ${props => props.theme.white};
    position: relative;

    ${props => (props.theme.colorTheme === 'dark') ? `background-color: ${props.theme.darkShade1};` : `background-color: ${props.theme.white};`}
`;

const Logo = styled.img`
    height: ${props => props.theme.scale * 140}px;
    max-width: ${props => props.theme.scale * 300}px;
    position: absolute;
    left: ${props => props.theme.scale * 40}px;
    top: ${props => props.theme.scale * 32}px;
`;

const BusComing = styled.img`
    height: ${props => props.theme.scale * 120}px;
    max-width: ${props => props.theme.scale * 300}px;
    position: absolute;
    right: ${props => props.theme.scale * 40}px;
    top: ${props => props.theme.scale * 72}px;
`;

const Info = styled.div`
    position: absolute;
    right: ${props => props.theme.scale * 32}px;
    top: ${props => props.theme.scale * 32}px;
    display: flex;    
    font-size:  ${props => props.theme.scale * 26}px;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const Place = styled.div`
    font-family: 'MuseoSans-900';
    color: ${props => props.theme.place};
    text-transform: uppercase;
    margin-right: ${props => props.theme.scale * 20}px;
    font-size:  ${props => props.theme.scale * 24}px;
`;

const Date = styled.div`
    font-family: 'MuseoSans-300';
    margin-right: ${props => props.theme.scale * 10}px;
    font-size:  ${props => props.theme.scale * 26}px;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const Time = styled.div`
    font-family: 'MuseoSans-900';
    margin-left: ${props => props.theme.scale * 10}px;
    font-size: ${props => props.theme.scale * 26}px;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const Ligne = styled.div`
    position: absolute;
    bottom: 40px;
    right: 260px;
    text-align: right;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const LigneNumber = styled.div`
    font-family: 'MuseoSans-900';
    font-size: ${props => props.theme.scale * 46}px;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const LignePlace = styled.div`
    font-family: 'MuseoSans-300';
    font-size: ${props => props.theme.scale * 30}px;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const TimeUntil = styled.div`
    position: absolute;
    right: 30px;
    bottom: 50px;
    font-family: 'MuseoSans-900';
    font-size: ${props => props.theme.scale * 56}px;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const Error = styled.div`
    box-sizing: border-box;
    position: absolute;
    top: ${props => props.theme.scale * 100}px;
    right: ${props => props.theme.scale * 30}px;
    text-align: right;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const ErrorTitle = styled.div`
    font-size: ${props => props.theme.scale * 34}px;
    font-family: 'MuseoSans-900';
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const ErrorUrl = styled.div`
    font-size: ${props => props.theme.scale * 30}px;
    font-family: 'MuseoSans-300';
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const pad = (num, size) => {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
}

const Header = () => {
    const customer = useSelector(state => state.config.customer);
    const location = useSelector(state => state.config.location);
    const mobilite = useSelector(state => state.data.mobilite);
    const themeContext = useContext(ThemeContext)
    const [time, setTime] = useState(dayjs().format('HH:mm'));
    const [date, setDate] = useState(dayjs().format('DD.MM.YYYY'));

    useEffect(() => {
        let interval = null;
        
        interval = setInterval(() => {
            let newTime = dayjs().format('HH:mm');
            let newDate = dayjs().format('DD.MM.YYYY');
            setTime(newTime);
            setDate(newDate);
        }, 1000);
        
        return () => clearInterval(interval);
    }, [time, date]);

    if (!location) return(null);

    let logo = images.logos[customer];
    if (themeContext.colorTheme === 'dark') {
        logo = images.logosDark[customer];
    }
    
    let bus;
    let busIcon;
    let isThere;

    if (mobilite) {
        if (mobilite.busList) {

            bus = mobilite.busList[0];
            let time = dayjs(`${bus.date} ${bus.time}`);
            let now = dayjs();
            let diff = time.diff(now,'minute', true);

            if (diff > 0) {
                bus.until = pad(Math.ceil(diff), 2);
                isThere = false;
            }
            else {
                console.log(diff < 0)
                isThere = true;
                busIcon = `/images/icons/ic_bus.svg`;
                bus.until = "00";
            }
        }
    }

    return(
        <HeaderWrapper>
            <Logo src={logo} className="smart-touch__logo" alt="logo" />
            <Info>
                <Place>{location.mobilite}</Place><Date>{date}</Date>|<Time>{time}</Time>
            </Info>
            {<React.Fragment>
                    <Ligne>
                        <LigneNumber>{bus.name}</LigneNumber>
                        <LignePlace>{bus.direction}</LignePlace>
                    </Ligne>
                    <TimeUntil>{bus.nextbusinMin} min</TimeUntil>
                </React.Fragment>

            }
        </HeaderWrapper>
    )
}

export default Header;